import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { CustomHeaderDirective } from '@app/infrastructure/data-list/grid/sort-header/custom-header.directive';
import { SortHeaderComponent } from '@app/infrastructure/data-list/grid/sort-header/sort-header.component';
import { PaginationModule } from '@app/infrastructure/data-list/pagination/pagination.module';
import { CollapsibleRowDirective } from '@app/infrastructure/data-list/table/directives/collapsible-row.directive';
import { CustomCellDirective } from '@app/infrastructure/data-list/table/directives/custom-cell.directive';
import { CustomRowDirective } from '@app/infrastructure/data-list/table/directives/custom-row.directive';
import { EmptyValueModule } from '@app/infrastructure/pipes/empty-value/empty-value.module';
import { FullTextTooltipModule } from '@app/infrastructure/tooltips/full-text-tooltip/full-text-tooltip.module';
import { GridComponent } from './grid.component';
import { TipBooleanModule } from '@app/components/tip-boolean/tip-boolean.module';

@NgModule({
	declarations: [
		GridComponent,
		SortHeaderComponent,
		CustomRowDirective,
		CustomCellDirective,
		CollapsibleRowDirective,
		CustomHeaderDirective,
	],
	imports: [
		CommonModule,
		FullTextTooltipModule,
		EmptyValueModule,
		PaginationModule,
		MatFormFieldModule,
		MatIconModule,
		TipBooleanModule,
	],
	exports: [
		GridComponent,
		SortHeaderComponent,
		CustomCellDirective,
		CustomRowDirective,
		CollapsibleRowDirective,
		CustomHeaderDirective,
	],
})
export class GridModule {}
